import { getAccountsApi } from "@Shared/@Utils/ajax";
export const get = async () => {
  const path = window.location.pathname.replace("/", "").replace("#", "");
  const endpoint = `/subdomain/${path}?client=true`;
  const {
    accountDetails
  } = await getAccountsApi({}, endpoint);
  return {
    externalServices: accountDetails.externalServices
  };
};